import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 1 };
import usePlanner from '@/composables/usePlanner';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Profile from '@/components/planner/Profile.vue';
import AdminNoteList from '@/components/adminNote/AdminNoteList.vue';
import Messages from '@/components/message/Messages.vue';
import { NoteableType } from '@/models/adminNote';
import useContract from '@/composables/useContract';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Show',
    setup(__props) {
        const { planner, fetchById } = usePlanner();
        const route = useRoute();
        const plannerId = ref(0);
        const { contracts, fetchData, form } = useContract();
        onMounted(async () => {
            console.log(route.params.id);
            plannerId.value = Number(typeof route.params.id == 'string' ? route.params.id : 0);
            await fetchById(plannerId.value);
            form.value.plannerIds = [plannerId.value];
            form.value.pageSize = 100;
            fetchData();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("h1", null, "プランナー: " + _toDisplayString(_unref(planner)?.user?.name), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "planner-title" }, "契約一覧", -1)),
                                    _createElementVNode("table", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contracts), (contract) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/contract/${contract.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(contract.id), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(contract.companyName), 1),
                                                _createElementVNode("td", null, _toDisplayString(contract.jobSections), 1),
                                                _createElementVNode("td", null, _toDisplayString(contract.jobTitle), 1),
                                                _createElementVNode("td", null, _toDisplayString(contract.statusText), 1)
                                            ]));
                                        }), 256))
                                    ]),
                                    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "planner-title" }, "プランナープロフィール", -1)),
                                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "planner-title" }, "プロフィールチェック", -1)),
                                    _createElementVNode("p", null, _toDisplayString(_unref(planner)?.isChecking ? 'プロフィールチェック申請中' : 'なし'), 1),
                                    (_unref(planner))
                                        ? (_openBlock(), _createBlock(Profile, {
                                            key: 0,
                                            planner: _unref(planner)
                                        }, null, 8, ["planner"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1,
                                __: [0, 1, 2]
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "planner-title" }, "プランナーメモ", -1)),
                                    _createVNode(AdminNoteList, {
                                        "noteable-id": _unref(planner)?.id ?? 0,
                                        "noteable-type": _unref(NoteableType).PlannerMode,
                                        mode: "all"
                                    }, null, 8, ["noteable-id", "noteable-type"]),
                                    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "planner-title" }, "メッセージ", -1)),
                                    (_unref(planner)?.user?.id)
                                        ? (_openBlock(), _createBlock(Messages, {
                                            key: 0,
                                            "to-user-id": _unref(planner)?.user?.id ?? 0,
                                            "from-user-id": 0
                                        }, null, 8, ["to-user-id"]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_1, "ユーザーが読み込まれていません"))
                                ]),
                                _: 1,
                                __: [3, 4]
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
